import React from 'react';
import { Check } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { ZodiacTheme } from './zodiacThemes';
interface SubscriptionsTabProps {
  theme: ZodiacTheme;
  onNavigate: (page: string) => void;
}
export function SubscriptionsTab({
  theme,
  onNavigate
}: SubscriptionsTabProps) {
  return <div className="space-y-6" data-id="element-16243">
      <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-16244">
        Управление подпиской
      </h2>
      <Card padding="lg" className={`border-2 ${theme.border} ${theme.ring} shadow-md relative overflow-hidden`} data-id="element-16245">
        <div className={`absolute top-0 right-0 bg-gradient-to-r ${theme.gradient} text-white text-xs font-bold px-3 py-1 rounded-bl-lg`} data-id="element-16246">
          Активна
        </div>
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6 mb-8" data-id="element-16247">
          <div data-id="element-16248">
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-16249">
              Astriqo Plus
            </h3>
            <p className="text-slate-600" data-id="element-16250">
              Ежемесячная подписка для глубокого погружения
            </p>
          </div>
          <div className="text-right" data-id="element-16251">
            <div className="text-3xl font-bold text-slate-900" data-id="element-16252">
              990 ₽{' '}
              <span className="text-lg font-normal text-slate-500" data-id="element-16253">/ мес</span>
            </div>
            <div className="text-sm text-slate-500 mt-1" data-id="element-16254">
              Следующее списание: 12 Ноя 2024
            </div>
          </div>
        </div>

        <div className="bg-slate-50 rounded-xl p-6 mb-8" data-id="element-16255">
          <h4 className="font-bold text-slate-900 mb-4" data-id="element-16256">Ваши преимущества:</h4>
          <ul className="space-y-3" data-id="element-16257">
            <li className="flex items-start text-sm text-slate-700" data-id="element-16258">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16259" />{' '}
              1 бесплатный отчёт каждый месяц (Доступно: 1)
            </li>
            <li className="flex items-start text-sm text-slate-700" data-id="element-16260">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16261" />{' '}
              Скидка 20% на консультации астрологов
            </li>
            <li className="flex items-start text-sm text-slate-700" data-id="element-16262">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16263" />{' '}
              Доступ к закрытым статьям блога
            </li>
            <li className="flex items-start text-sm text-slate-700" data-id="element-16264">
              <Check className="w-5 h-5 text-emerald-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-16265" />{' '}
              PRO Персональный календарь транзитов
            </li>
          </ul>
        </div>

        <div className="flex flex-col sm:flex-row gap-4" data-id="element-16266">
          <Button variant="primary" onClick={() => onNavigate('pricing')} data-id="element-16267">
            Сменить тариф
          </Button>
          <Button variant="outline" className="text-rose-600 hover:text-rose-700 hover:bg-rose-50 border-rose-200" data-id="element-16268">
            Отменить подписку
          </Button>
        </div>
      </Card>
    </div>;
}